<template>
  <div class="locale-font">
    <div class="breadcrumb-container">
        <v-breadcrumbs :items="breadcrumbsItem"></v-breadcrumbs>
    </div>
    <h1 class="head-line-page mb-5">
        {{ breadcrumbsItem[1].text }}
    </h1>
    <div class="container-info">
        <v-card class="profile-card">
            <p class="content-header">
                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.visitorInfo') }}
            </p>
            <div class="d-flex">
                <div class="upload-container">
                    <upload-image
                        ref="uploadImage"
                        :img="imgProfile(visitorData.profileImage)"
                        :isEditing="false"
                        :canDelete="false">
                    </upload-image>
                </div>
                <!-- VISITOR PROFILE --->
                <div class="profile-container">
                    <div class="row">
                        <div class="mb-4">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.citizenIdPassportId') }}
                            </div>
                            <div class="data-profile">
                                {{ visitorData.citizenId }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 pl-0 pr-0">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.visitorName') }}
                            </div>
                            <div class="data-profile">
                                {{ visitorData.firstName }}
                            </div>
                        </div>
                        <div class="col-6 pl-0 pr-0">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.visitorSurname') }}
                            </div>
                            <div class="data-profile">
                                {{ visitorData.lastName }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 pl-0 pr-0">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.visitorGender') }}
                            </div>
                            <div class="data-profile">
                                {{ getGender(visitorData.gender) }}
                            </div>
                        </div>
                        <div class="col-6 pl-0 pr-0">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.visitAt') }}
                            </div>
                            <div class="data-profile">
                                {{ visitorData.organizationName }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 pl-0 pr-0">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.emailAddress') }}
                            </div>
                            <div class="data-profile">
                                {{ visitorData.email }}
                            </div>
                        </div>
                        <div class="col-6 pl-0 pr-0">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.phoneNumber') }}
                            </div>
                            <div class="data-profile">
                                {{ visitorData.phone }}
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 pl-0 pr-0">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.operator') }}
                            </div>
                            <div class="data-profile">
                                {{ visitorData.operatorId }}
                            </div>
                        </div>
                        <div class="col-6 pl-0 pr-0">
                            <div class="label-profile">
                                {{ this.$vuetify.lang.t('$vuetify.visitorInfo.visitorStatus') }}
                            </div>
                            <div class="data-profile">
                                <v-btn
                                    class="status-btn absolute"
                                    :color="getColorStatus(visitorData.status)"
                                    rounded
                                    large
                                    depressed>
                                    {{ getTextStatus(visitorData.status) }}
                                 </v-btn>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 pl-0 pr-0">
                            <img class="card-image" :src="imgProfile(visitorData.cardImage)">
                        </div>
                    </div>
                </div>
                <!-- VISITOR PROFILE --->
            </div>
        </v-card>
        <div class="activity-log-card">
            <activity-log :logItems="visitorActivity" />
        </div>
    </div>
  </div>
</template>

<script>
import ActivityLog from '@/components/ActivityLog.vue'
import UploadImage from '@/components/UploadImage'
import profileDefault from '@/assets/user_default.png'
export default {
    name: 'VisitorInfo',

    components: {
        ActivityLog,
        UploadImage
    },

    data () {
        return {
            visitorId: null,
            visitorData: {},
            visitorActivity: []
        }
    },

    computed: {
        breadcrumbsItem () {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.visitor.visitor'),
                    disabled: false,
                    exact: true,
                    to: {
                        name: 'Visitor'
                    }
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.visitorInfo.visitorView'),
                    disabled: true
                }
            ]
        }
    },

    methods: {
        getGender (gender) {
            if (gender === 'M') {
                return this.$vuetify.lang.t('$vuetify.visitorInfo.male')
            } else if (gender === 'F') {
                return this.$vuetify.lang.t('$vuetify.visitorInfo.female')
            } else {
                return this.$vuetify.lang.t('$vuetify.visitorInfo.others')
            }
        },

        getTextStatus (status) {
            if (status === 'ACT') {
                return this.$vuetify.lang.t('$vuetify.visitorInfo.visitorActive')
            } else if (status === 'DEA') {
                return this.$vuetify.lang.t('$vuetify.visitorInfo.visitorDeactive')
            }
        },

        getColorStatus (status) {
            if (status === 'ACT') {
                return '#6c98ba'
            } else if (status === 'DEA') {
                return '#ff544a'
            }
        },

        responeMsgNotify (title, msg, type) {
            this.$notify({
                title: title,
                text: msg,
                type: type
            })
        },

        async getVisitorInfo () {
            const res = await this.axios.get(`/visitor/${this.visitorId}/view`)
            if (res && res.data && res.data.status === 'ok') {
                this.visitorData = res.data.data
            } else {
                this.responeMsgNotify('Error', res.data.msg, 'notify-error')
            }
        },

        async getVisitorActivity () {
            const res = await this.axios.get(`visitor/activity-log/${this.visitorId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.visitorActivity = res.data.data
            }
        },

        imgProfile (img) {
            if (img) {
                return img
            } else {
                return profileDefault
            }
        }
    },

    async mounted () {
        this.visitorId = this.$route.params.id
        this.$store.dispatch('setLoading', true)
        await this.getVisitorInfo()
        await this.getVisitorActivity()
        this.$store.dispatch('setLoading', false)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                this.$store.dispatch('setLoading', true)
                await this.getVisitorInfo()
                await this.getVisitorActivity()
                this.$store.dispatch('setLoading', false)
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
    .container-info {
        display: grid;
        min-height: 100%;
        height: 100%;
        margin-bottom: 0rem;
        grid-gap: 25px;
        grid-template-columns: calc(66% - 12.5px) calc(34% - 12.5px);

        .profile-card {
            padding: 36px 38px;
            border-radius: 15px;
        }

        .activity-log-card {
            border-radius: 15px;
        }

        .label-profile {
            color: #6c6c6c;
            font-size: 14px;
            font-weight: normal;
        }

        .data-profile {
            font-size: 16px;
            font-weight: normal;
            color: #131410;
        }

        .upload-container {
            min-width: 160px;
            width: 22%;
        }

        .profile-container {
            width: 78%;

            .status-btn {
                pointer-events: none;
                color: #FFFFFF !important;
                caret-color: #FFFFFF !important;
            }
        }

        img {
            display: block;
        }

        .card-image {
            border-radius: 3%;
            height: 90px;
            margin-bottom: 10px;
        }
    }
</style>
